<template>
    <div  class="glogo">
        <van-row>
            <van-col span="24">
                <Header :title="title"></Header>
            </van-col>
        </van-row>
        <van-row class="logo">
            <van-col span="24">
                <van-image
                        width="180px"
                        height="150px"
                        fit="contain"
                        :src= logo
                />
            </van-col>
        </van-row>
        <van-row>
            <van-col span="24">
                <van-form @submit="onSubmit"
                          validate-first
                          :show-error = "false"
                          :show-error-message = "false"
                          @failed="onFailed" >
                    <van-field
                            v-model="mobile"
                            type="number"
                            name="mobile"
                            :label='$t( "login.phone" )'
                            :placeholder='$t( "login.phone" )'
                            :rules="formRules.mobile"
                    />
                    <van-field
                            v-model="password"
                            type="password"
                            name="password"
                            :label='$t( "login.password" )'
                            :placeholder='$t( "login.password" )'
                            :rules="formRules.password"
                    />
                    <van-field
                            v-model="repassword"
                            type="password"
                            name="repassword"
                            :label='$t( "reg.repassword" )'
                            :placeholder='$t( "reg.repassword" )'
                            :rules="formRules.repassword"
                    />
                    <van-field
                            v-model="sms"
                            center
                            clearable
                            name = "sms"
                            :label='$t( "reg.sms" )'
                            :placeholder='$t( "reg.sms_msg" )'
                            :rules="formRules.sms"
                    >

                        <template #button>
                            <van-count-down :time="1000*60" format = "ss s" v-if="isCountDownShow" @finish ="isCountDownShow  = false"/>
                            <van-button size="small" type="primary" v-else @click="sendsms" native-type="button" >{{ $t('reg.sendsms' )}}</van-button>
                        </template>
                    </van-field>
                    <div style="margin: 16px;">
                        <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" block type="info" native-type="submit">{{ $t('reg.reg' )}}</van-button>
                    </div>
                </van-form>
            </van-col>
        </van-row>
        <van-row class="regbtn">
            <router-link to="Forget"><van-col span="12">{{ $t('login.Forget' )}}</van-col></router-link>
            <router-link to="Login"><van-col span="12">{{ $t('login.login' )}}</van-col></router-link>
        </van-row>
        <van-row class="foot">
            <van-col span="24">{{ $t('reg.agreement' )}}</van-col>
        </van-row>
    </div>
</template>

<script>
    import Header from '@/components/Header'


    export default {
        name: "Reg",

        data(){
            return{
                title:this.$t('reg.reg'),
                mobile:'',
                password:'',
                repassword:'',
                logo:require('../assets/images/ic_login_logo.png'),
                sms:'',
                inerror:'',
                isCountDownShow: false, //控制倒记时
                formRules:{
                    mobile:[{ required: true,validator: this.asyncValidator, message: this.$t('reg.vaildphone') }],
                    password: [{ pattern:/.{6}/, message: this.$t('login.pass_msg') }],
                    repassword:[{ validator:this.uniformity, message: this.$t('reg.reppass') }],
                    sms:[{ required: true, message: this.$t('reg.sms_msg') }]
                }
            }
        },
        methods: {
            onSubmit(values) {
                if(values){
                    this.postReq('/reg',values).then(res=>{
                        if(res){
                            const tokenStr = res.data.token;
                            window.localStorage.setItem('tokenStr',tokenStr);
                            //跳转
                            this.$router.replace('/');
                        }
                    })
                }
            },
            asyncValidator(val) {
                return new Promise((resolve) => {
                    this.$toast.loading(this.$t('reg.vading'));

                    this.getReq('/validphone',{mobile:val}).then((res)=>{
                        this.$toast.clear();
                         resolve(res)
                    })
                })
            },
            uniformity(val){
              if(val!=this.password){
                  return false;
              }
            },
            onFailed(errorInfo) {
                if(errorInfo.errors[0]){
                    this.$toast({
                        message : errorInfo.errors[0].message,
                        position : 'top'
                    })
                }
                this.inerror=errorInfo;
            },
           async sendsms(){
                if(this.mobile != ''&&this.password != ''&& this.repassword != ''){
                    this.isCountDownShow = true;
                    let checkmobile = await this.asyncValidator(this.mobile);

                    if(checkmobile){
                        this.getReq('/getvalidte',{
                            mobile:this.mobile
                        }).then((res)=>{
                            if(res.code===1){
                                this.$toast(this.$t('reg.sendok'))
                            }else{
                                this.$toast(this.$t('reg.sendfail'))
                            }
                        })
                    }else{
                        this.$toast(this.$t('reg.sendphone'));
                        return false;
                    }
                }else{
                    this.$toast(this.$t('reg.sendvaid'));
                }
            }
        },
        components:{
            Header
        }
    }
</script>

<style scoped lang="scss">
    .glogo{
        background: white;
    .logo{

    }
        .regbtn{
            margin: 30px auto;
        }
        .foot{
            margin: 30px auto;
        }
    }
</style>
